import * as React from 'react';
import { useState } from 'react';
import { Modal, Typography, Stack, Button, Box, TextField, Select, MenuItem } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { createRecomendation } from '@/features/dashboard/api/createRecomendation';

type PropsType = {
  id: string;
  name: string;
  open: boolean;
  handleClose: () => void;
  submit: () => void;
};

const NewRecomentadionModal: React.FC<PropsType> = ({ id, name, open, handleClose, submit }) => {
  const [text, setText] = useState('');

  const payload = { id, text };

  const onSubmit = async (values) => {
    try {
      const data = await createRecomendation({ id, text });

      enqueueSnackbar('recomendação cadastrada com sucesso!', {
        variant: 'success',
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
      });

      handleClose();
    } catch (e) {
      enqueueSnackbar((e as Error).message || 'Falha ao cadastrar recomendação!', {
        variant: 'error',
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
      });
    }
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '517px',
    width: '100%',
    bgcolor: '#fff',
    borderRadius: '20px',
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box style={{ background: '#93DC3F', borderRadius: '20px 20px 0 0', boxShadow: '0px 4px 4px 0px #00000040' }}>
            <Typography color={'#231F20'} variant="h1" p={'10px 29px'}>
              Dados do responsável e aluno
            </Typography>
          </Box>
          <Stack sx={{ p: '20px 30px 50px 30px' }} justifyContent={'center'}>
            <Stack flexDirection={'row'}>
              <Box width={'100%'}>
                <Typography fontSize={'20px'}>
                  Aluno(a): <span style={{ fontWeight: 'bold' }}>{name}</span>
                </Typography>

                <Typography color={'#E04A4C'} fontSize={'14px'} m={'20px 0'}>
                  *Em decorrência do aumento de inadimplência, é necessário o registro de uma advertência.
                </Typography>

                <Typography>Descrição de recomendação*</Typography>
                <TextField
                  onChange={(e) => setText(e.target.value)}
                  value={text}
                  fullWidth
                  required
                  id="description"
                  multiline
                  rows={6}
                  sx={{ background: '#F4F4F4' }}
                />
              </Box>
            </Stack>
            <Stack margin={'auto'} gap={'20px'} flexDirection={'row'}>
              <Button
                sx={{ width: '164px', borderRadius: '24px', fontSize: '14px', mt: '40px', bgcolor: '#D63429' }}
                variant="contained"
                onClick={handleClose}
              >
                Descartar
              </Button>
              <Button
                sx={{ width: '164px', borderRadius: '24px', fontSize: '14px', mt: '40px', bgcolor: '#15AB51' }}
                variant="contained"
                onClick={onSubmit}
              >
                Salvar
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default NewRecomentadionModal;
